import './CategoryFilters.css';
import React from 'react';
import { get } from '../../../../utils';
import CarouselProvider from '../../../atoms/CarouselProvider/CarouselProvider';
import useMobile from '../../../../utils/useMobile';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../../utils/tealium';
var transition = '0.3s linear';
var CategoryFilters = function CategoryFilters(_ref) {
  var categories = _ref.categories,
    chosenTypes = _ref.chosenTypes,
    checkboxesRef = _ref.checkboxesRef,
    _ref$withMapModalView = _ref.withMapModalView,
    withMapModalView = _ref$withMapModalView === void 0 ? false : _ref$withMapModalView,
    submitFilters = _ref.submitFilters,
    rtl = _ref.rtl,
    analytics = _ref.analytics,
    params = _ref.params;
  var isMobile = useMobile(769);
  var renderCategoryItem = function renderCategoryItem(category, index) {
    var mainTitle = get(category, 'title.jss.value') || '';
    var title = get(category, 'contentType.type.template.targetItem.value') || '';
    var itemSearchIndex = get(category, 'searchIndex.jss.fields.IndexName.value') || '';
    var nestedFilters = get(category, 'filters') || [];
    var svgIcon = get(category, 'svg.jss.value');
    var color = get(category, 'colourTheme.item.backgroundColor.jss.value') || 'var(--m113-interactive-map-background-color)';
    var key = "".concat(title, "-").concat(index);
    var isChecked = chosenTypes.length && chosenTypes.filter(function (el) {
      return el.value === title;
    }).length ? true : false;
    return /*#__PURE__*/React.createElement("div", {
      key: key,
      className: "imfilter-checkbox-item",
      style: {
        '--m114-imfilter-checkbox-color': color
      }
    }, /*#__PURE__*/React.createElement("input", {
      tabIndex: 0,
      value: title,
      type: "checkbox",
      checked: isChecked,
      "data-search-index": itemSearchIndex,
      "data-mainTitle": mainTitle,
      className: "imfilter-checkbox",
      id: "imfilter-".concat(title, "-").concat(index),
      name: "imfilter",
      title: title,
      onChange: function onChange(e) {
        tealiumClickFunc(tealiumMergeClickData(analytics['categoryAnalytics'], params), "".concat(mainTitle ? mainTitle : ''));
        submitFilters(e, key, index, nestedFilters);
      },
      onKeyPress: function onKeyPress(event) {
        tealiumClickFunc(tealiumMergeClickData(analytics['categoryAnalytics'], params), "".concat(mainTitle ? mainTitle : ''));
        submitFilters(event, key, index, nestedFilters);
      }
    }), (mainTitle || svgIcon) && /*#__PURE__*/React.createElement("label", {
      className: "imfilter-checkbox__label",
      htmlFor: "imfilter-".concat(title, "-").concat(index)
    }, svgIcon && /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: svgIcon
      },
      className: "imfilter-checkbox__svg"
    }), /*#__PURE__*/React.createElement("span", {
      className: "imfilter-checkbox-title ellipsis1"
    }, " ", mainTitle)));
  };
  var renderItems = function renderItems() {
    if (categories && categories.length) {
      return categories.map(function (item, index) {
        return renderCategoryItem(item, index);
      });
    }
    return [];
  };
  if (!categories) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  if (categories && !categories.length) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  if (withMapModalView) {
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, !isMobile ? categories && categories.length && /*#__PURE__*/React.createElement("div", {
    className: "imfilters-categories imfilters-padding",
    ref: checkboxesRef
  }, categories.map(function (item, index) {
    return renderCategoryItem(item, index);
  })) : /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref2) {
    var renderCarousel = _ref2.renderCarousel,
      renderPreviousButton = _ref2.renderPreviousButton,
      renderNextButton = _ref2.renderNextButton,
      renderDots = _ref2.renderDots,
      state = _ref2.state;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "imfilters-categories imfilters-padding",
      ref: checkboxesRef
    }, renderCarousel(renderItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 1200
          },
          items: 3,
          partialVisibilityGutter: 150
        },
        tabletLarge: {
          breakpoint: {
            max: 1199,
            min: 768
          },
          items: 3,
          partialVisibilityGutter: categories.length === 2 ? undefined : 20
        },
        tablet: {
          breakpoint: {
            max: 767,
            min: 480
          },
          items: 2,
          partialVisibilityGutter: categories.length === 2 ? undefined : 50
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 2,
          partialVisibilityGutter: categories.length === 2 ? undefined : 50
        }
      },
      containerClass: '',
      partialVisible: categories.length < 3 ? false : true
    })));
  }));
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: " ".concat(commonStyles, "  ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c1ewc83s";
var ltrStyles = "lr5qox2";
var rtlStyles = "rthh9m6";
export default CategoryFilters;